import React from "react";
import {
  SFStack,
  SFButtonGroup,
  SFSortButtonGroup,
  SFTypography,
  SFArrowDownWardIcon,
  SFArrowUpWardIcon,
} from "@sf-core";
import { Logger } from "@base-provider";

const BUTTONS = [
  {
    label: "Button 1",
    onClick: () =>
      Logger.of("App.buttonGroup.onClick").info({ clicked: "button 1" }),
  },
  {
    label: "Button 2",
    onClick: () =>
      Logger.of("App.buttonGroup.onClick").info({ clicked: "button 2" }),
  },
  {
    label: "Button 3",
    onClick: () =>
      Logger.of("App.buttonGroup.onClick").info({ clicked: "button 3" }),
  },
];

const BUTTONS_WITH_ICONS = [
  {
    label: "Button 1",
    onClick: () =>
      Logger.of("App.buttonGroup.onClick").info({ clicked: "button 1" }),
    icon: <SFArrowDownWardIcon size="small" />,
  },
  {
    label: "Button 2",
    onClick: () =>
      Logger.of("App.buttonGroup.onClick").info({ clicked: "button 2" }),
    icon: <SFArrowUpWardIcon size="small" />,
  },
];

const SORT_BUTTONS = [
  {
    label: "Button 1",
    field: "button1",
  },
  {
    label: "Button 2",
    field: "button2",
  },
];

const ButtonGroup = () => {
  return (
    <SFStack spacing={1}>
      <SFTypography variant="h6">Default</SFTypography>
      <SFButtonGroup buttons={BUTTONS} />
      <SFTypography variant="h6">With sort icons</SFTypography>
      <SFButtonGroup buttons={BUTTONS_WITH_ICONS} />
      <SFTypography variant="h6">
        With sort icons visible only when selected
      </SFTypography>
      <SFButtonGroup iconSelectedOnly buttons={BUTTONS_WITH_ICONS} />
    </SFStack>
  );
};

export default ButtonGroup;

export const SortButtonGroup = () => {
  return (
    <SFStack spacing={1}>
      <SFTypography variant="h6">Default</SFTypography>
      <SFSortButtonGroup
        onChange={(val) =>
          Logger.of("App.sortButtonGroup.onChange").info({ val })
        }
        buttons={SORT_BUTTONS}
      />
      <SFTypography variant="h6">With predefined sort</SFTypography>
      <SFSortButtonGroup
        onChange={(val) =>
          Logger.of("App.sortButtonGroup.onChange").info({ val })
        }
        buttons={SORT_BUTTONS}
        defaultSort={{field: "button2", sort: "desc"}}
      />
    </SFStack>
  );
};
